var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendsAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "friends-svg",
    width: 114,
    height: 75,
    viewBox: "0 0 114 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "friends",
    clipPath: "url(#clip0_4806_38276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2852 64.1795V17.4297C73.2852 8.43682 65.9952 1.14453 57 1.14453C48.0071 1.14453 40.7148 8.43453 40.7148 17.4297V73.4219",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.941 18.8784C12.941 18.8784 11.5128 16.6719 9.63135 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4088 18.8784C27.4088 18.8784 25.9806 16.6719 24.0991 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7149 73.4219V17.4297C34.7149 8.43682 27.4249 1.14453 18.4297 1.14453C9.43453 1.14453 2.14453 8.43453 2.14453 17.4297V73.4219",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4901 26.8186C23.4901 29.7323 21.128 32.0944 18.2143 32.0944C15.3006 32.0944 12.9385 29.7323 12.9385 26.8186",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5618 26.3835C62.5231 26.3835 63.2029 27.5028 62.8939 28.5831C62.1226 31.2657 59.9779 33.1975 57.4556 33.1975C54.931 33.1975 52.7886 31.268 52.0173 28.5831C51.7083 27.5051 52.3881 26.3835 53.3494 26.3835H61.5664H61.5618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14453 42.8633V44",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 49.717V47.5V45.5",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.059 18.8784C101.059 18.8784 102.487 16.6719 104.369 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5913 18.8784C86.5913 18.8784 88.0196 16.6719 89.901 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2852 64.1795V17.4297C79.2852 8.43682 86.5752 1.14453 95.5703 1.14453C104.563 1.14453 111.856 8.43453 111.856 17.4297V73.4219",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5098 26.8186C90.5098 29.7323 92.8719 32.0944 95.7856 32.0944C98.6993 32.0944 101.061 29.7323 101.061 26.8186",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.855 42.8633L111.856 45",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 51.5V49.283L112 47",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4883 21.0437C51.6576 21.0437 52.6055 20.0958 52.6055 18.9265C52.6055 17.7572 51.6576 16.8093 50.4883 16.8093C49.319 16.8093 48.3711 17.7572 48.3711 18.9265C48.3711 20.0958 49.319 21.0437 50.4883 21.0437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5669 21.0437C65.7362 21.0437 66.6841 20.0958 66.6841 18.9265C66.6841 17.7572 65.7362 16.8093 64.5669 16.8093C63.3976 16.8093 62.4497 17.7572 62.4497 18.9265C62.4497 20.0958 63.3976 21.0437 64.5669 21.0437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2852 73.7515V71.9753",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "friends-close",
    clipPath: "url(#clip0_4806_38275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2852 64.1795V17.4297C73.2852 8.43682 65.9952 1.14453 57 1.14453C48.0071 1.14453 40.7148 8.43453 40.7148 17.4297V73.4219",
    stroke: "#FF7900",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7965 18.8784C18.7965 18.8784 17.3683 16.6719 15.4868 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2643 18.8784C33.2643 18.8784 31.836 16.6719 29.9546 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5704 73.4219V17.4297C40.5704 8.43682 33.2804 1.14453 24.2852 1.14453C15.29 1.14453 8 8.43453 8 17.4297V73.4219",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3456 26.8186C29.3456 29.7323 26.9835 32.0944 24.0698 32.0944C21.156 32.0944 18.7939 29.7323 18.7939 26.8186",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5618 26.3835C62.5231 26.3835 63.2029 27.5028 62.8939 28.5831C62.1226 31.2657 59.9779 33.1975 57.4556 33.1975C54.931 33.1975 52.7886 31.268 52.0173 28.5831C51.7083 27.5051 52.3881 26.3835 53.3494 26.3835H61.5664H61.5618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand",
    d: "M8 42.8633L23.1179 57.9789",
    stroke: "#FF7900",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand",
    d: "M17.1416 59.1485L16.9219 51.783H24.07",
    stroke: "#FF7900",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7739 18.8784C94.7739 18.8784 96.2022 16.6719 98.0836 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3062 18.8784C80.3062 18.8784 81.7344 16.6719 83.6158 18.8784",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 64.1795V17.4297C73 8.43682 80.29 1.14453 89.2852 1.14453C98.2781 1.14453 105.57 8.43453 105.57 17.4297V73.4219",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2246 26.8186C84.2246 29.7323 86.5867 32.0944 89.5004 32.0944C92.4141 32.0944 94.7762 29.7323 94.7762 26.8186",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand",
    d: "M105.571 42.8633L90.4526 57.9789",
    stroke: "#FF7900",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand",
    d: "M96.4287 59.1485L96.6484 51.783H89.498",
    stroke: "#FF7900",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4883 21.0437C51.6576 21.0437 52.6055 20.0958 52.6055 18.9265C52.6055 17.7572 51.6576 16.8093 50.4883 16.8093C49.319 16.8093 48.3711 17.7572 48.3711 18.9265C48.3711 20.0958 49.319 21.0437 50.4883 21.0437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5669 21.0437C65.7362 21.0437 66.6841 20.0958 66.6841 18.9265C66.6841 17.7572 65.7362 16.8093 64.5669 16.8093C63.3976 16.8093 62.4497 17.7572 62.4497 18.9265C62.4497 20.0958 63.3976 21.0437 64.5669 21.0437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2852 73.7515V71.9753",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4806_38276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 75,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsAnimation);
export default __webpack_public_path__ + "static/media/friends-animation.588cf53ee003da555c5772852797d18a.svg";
export { ForwardRef as ReactComponent };